var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticClass: "pageSize",
      staticStyle: { margin: "0 auto", "padding-top": "15px" },
    },
    [
      _c("Head", { attrs: { homeTitle: "销售适当性" } }),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", {
            staticClass: "line_border_bottom el-tabs__item",
            attrs: { span: 1 },
          }),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 23 } },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.latestReload },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "我的列表", name: "first" } },
                    [
                      _c("LatestEvaluation", {
                        ref: "latest",
                        on: {
                          redirectRiskLevelDataBase:
                            _vm.redirectRiskLevelDataBase,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "基金详情", name: "second" } },
                    [_c("RiskLevelDataBase", { ref: "riskDB" })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "公司评价", name: "third" } },
                    [_c("CompanyEvaluation", { ref: "companyEvaluation" })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "方法论", name: "fourth" } },
                    [_c("Methodology", { ref: "methodology" })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "基金筛选", name: "fifth" } },
                    [
                      _c("FundSelector", {
                        ref: "fundSelector",
                        on: {
                          redirectRiskLevelDataBase:
                            _vm.redirectRiskLevelDataBase,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "风险画像", name: "seventh" } },
                    [_c("RiskPortrait", { ref: "riskPortrait" })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        disabled: !_vm.showRiskDetail,
                        label: "子项风险",
                        name: "eighth",
                      },
                    },
                    [
                      _c("RiskDetail", {
                        ref: "riskDetail",
                        on: {
                          redirectRiskLevelDataBase:
                            _vm.redirectRiskLevelDataBase,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }